jQuery(document).ready(function($) {

    var html = '<nav class="panel"><ul>';

    $('.navbar-nav>.nav-item, .meta-nav>.nav-item').each(function() {

        var link = $(this).find('a:first').attr('href');
        var title = $(this).find('a:first').text();

        if ($(this).find('.submenu').length) {

            html += '<li><div class="openSubPanel">' + title + '</div>';
            html += '<ul class="subPanel"> <li class="closeSubPanel"></li>';
            html += '<li>' + '<a href="' + link + '">' + title + '</a></li>';

            $(this).find('.submenu').find('li').each(function() {
                var link = $(this).find('a:first').attr('href');
                var title = $(this).find('a:first').text();

                html += '<li>' + '<a href="' + link + '">' + title + '</a></li>';
            });

            html += '</ul>';
        } else {
            html += '<li><a href="' + link + '">' + title + '</a></li>';
        }
    });

    $('.navbar-nav>.nav-btn').each(function() {
        html += '<div class="mt-3">' + $(this).html() + '</div>';
    });

    html += '</ul></nav>';

    $('#panel').append(html);


    $('.menuTrigger').click(function() {
        $(this).toggleClass('isActive');
        $('.panel').toggleClass('isOpen');
        $('.wrapper').toggleClass('pushed');

        if ($(this).hasClass('isActive')) {

            $('header').height('100%');
            $('body').css('overflow', 'hidden');

        } else {

            setTimeout(function() {
                $('header').height('auto');
                $('body').css('overflow', 'auto');
            }, 400)
        }
    });

    $('.openSubPanel').click(function() {
        $(this).next('.subPanel').addClass('isOpen');
    });

    $('.closeSubPanel').click(function() {
        $('.subPanel').removeClass('isOpen');
    });

    $('.closePanel').click(function() {
        $('.panel').removeClass('isOpen');
        $('.wrapper').removeClass('pushed');
    });

});